// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"19016ed6","347":"8ac61e27","536":"86453db9","714":"7cfe6843","850":"da76b45e","972":"f144d947"}[chunkId] + ".chunk.js";
};